import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

interface EnterExitProps{
  visible?: boolean;
  translate?: number;
  delay?: number;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

const EnterExit : React.FC<EnterExitProps> = (props) => {
  const { visible, translate, delay, children, style, className } = props;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{
            opacity: 0,
            translateY: -translate
          }}
          animate={{
            opacity: 1,
            translateY: 0,
            transition: {
              delay: delay,
            }
          }}
          exit={{
            opacity: 0,
            translateY: translate
          }}
          style={style}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

EnterExit.defaultProps = {
  visible: false,
  translate: 10,
  delay: .5,
};

export default EnterExit;
